import { Injectable } from '@angular/core';

import { Observable, map, share } from 'rxjs';

import { Container } from '@shared/models';
import { AddContainerCommand, UpdateContainerCommand } from '@shared/models/commands';
import { AbstractApiServiceBase } from './abstract-data.service';
import { HttpHeaders } from '@angular/common/http';


@Injectable({ providedIn: 'root' })
export class ContainersDataService extends AbstractApiServiceBase {

  getAll(): Observable<Container[]> {
    const url = `${this.getBaseApiUrl()}/containers/all`;
    return this.http.get<Container[]>(url).pipe(
      share(),
      map(items => items.map(item => new Container(item)))
    );
  }

  get(containerCode: string): Observable<Container> {
    const url = `${this.getBaseApiUrl()}/containers/${encodeURI(containerCode)}`;
    return this.http.get<Container>(url).pipe(
      map(item => new Container(item))
    );
  }

  add(command: AddContainerCommand): Observable<Container> {
    const url = `${this.getBaseApiUrl()}/containers`;
    const headers = this.getJsonHeader();
    const body = JSON.stringify(command);
    return this.http.post<Container>(url, body, { headers }).pipe(
      map(response => new Container(response))
    );
  }

  update(command: UpdateContainerCommand): Observable<Container> {
    const url = `${this.getBaseApiUrl()}/containers/${encodeURI(command.containerCode)}/update`;
    const headers = this.getJsonHeader();
    const body = JSON.stringify(command);
    return this.http.put<Container>(url, body, { headers }).pipe(
      map(response => new Container(response))
    );
  }

  delete(containerCode: string): Observable<void> {
    const url = `${this.getBaseApiUrl()}/containers/${encodeURI(containerCode)}`;
    return this.http.delete<void>(url);
  }

  export(): Observable<Blob> {
    const url = `${this.getBaseApiUrl()}/containers/export`;
    return this.http.get(url, { responseType: 'blob' });
  }

  import(file: File): Observable<any> {
    const url = `${this.getBaseApiUrl()}/containers/import`;
    const formData = new FormData();
    formData.append('file', file);
    const headers = new HttpHeaders();
    return this.http.post<any>(url, formData, { headers });
  }
}


